import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useFiles } from '../hooks/useFilesContext.js';

function BreadcrumbNav() {
  const { currentFolder, folders, navigateToFolder } = useFiles();

  const getCurrentPath = () => {
    const rootFolder = folders.find(folder => folder.is_main);
    if (!rootFolder) return ['Início'];
    
    if (currentFolder === rootFolder.id) return ['Início'];
    
    const buildPath = (folderId) => {
      if (!folderId || folderId === rootFolder.id) return [];
      const folder = folders.find(f => f.id === folderId);
      return folder ? [folder.name, ...buildPath(folder.parent_folder_id)] : [];
    };
    
    return ['Início', ...buildPath(currentFolder)];
  };

  const handlePathClick = (index) => {
    if (index === 0) {
      const rootFolder = folders.find(folder => folder.is_main);
      navigateToFolder(rootFolder?.id);
      return;
    }

    const path = getCurrentPath();
    const targetFolder = folders.find(folder => folder.name === path[index]);
    if (targetFolder) {
      navigateToFolder(targetFolder.id);
    }
  };

  const path = getCurrentPath();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      {path.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <Typography color="text.secondary">/</Typography>}
          {index === path.length - 1 ? (
            <Typography color="text.primary">{item}</Typography>
          ) : (
            <Link
              component="button"
              variant="body1"
              onClick={() => handlePathClick(index)}
              sx={{ textDecoration: 'none' }}
            >
              {item}
            </Link>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}

export default BreadcrumbNav; 